export const range = (start: number, end: number) => {
  let length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const capitalizeFirstLetter = (str: string | undefined): string => {
  if (!str) return "";
  if (str.length === 1) return str.toUpperCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatDate = (isoDate: Date) => {
  const date = new Date(isoDate);

  const options: Intl.DateTimeFormatOptions = {
    month: "short", // Сокращенное название месяца
    day: "numeric", // Число месяца
    year: "numeric", // Полный год
    hour: "numeric", // Часы
    minute: "numeric", // Минуты
    hour12: true, // Формат 12 часов
  };

  // Форматируем дату
  const formattedDate = date.toLocaleString("en-US", options);

  // Заменяем запятую на пробел перед "a.m." или "p.m."
  return formattedDate.replace(",", " ");
};

export const formatDateForChat = (dateString: string): string => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("de-DE", { month: "long" });

  return `${day} ${month}`;
};
